import axios from 'axios';
import getItemFromLocalStorage from 'utils/getItemFromLocalStorage';

// Create a custom event for token expiration
const dispatchTokenExpired = () => {
  window.dispatchEvent(new CustomEvent('tokenExpired'));
};

// Create a custom event for authentication required
const dispatchAuthRequired = () => {
  window.dispatchEvent(new CustomEvent('authRequired'));
};

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    
    if (response && response.status === 401) {
      const user = getItemFromLocalStorage('user');
      if (user) {
        console.log('Token expired, clearing storage and redirecting to login');
        localStorage.clear();
        dispatchTokenExpired();
        dispatchAuthRequired();
      }
    }
    
    return Promise.reject(error);
  },
);

export default axios;